import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import 'fg-frontend/plugins/jquery.gm';

class GoogleMapContacts extends WebComponent {
	constructor(props) {
		super(props);
	}

	didMount() {
		this.map = $(this.element);

		this.pointLatitude = this.element.dataset.pointLat;
		this.pointLongitude = this.element.dataset.pointLng;
		this.pointMarkerIcon = this.element.dataset.markerIcon;
		this.pointZoomDefault = 16;

		this.markerData = [{
			"id": 1,
			"type": 1,
			"lat": parseFloat(this.pointLatitude),
			"lng": parseFloat(this.pointLongitude),
		}];

		this.additionalMarkers = this.element.dataset.markers;
		this.additionalMarkersArray = '';
		if(this.additionalMarkers) {
			this.additionalMarkersJson = JSON.parse(this.additionalMarkers);
			for(let i = 0; i < this.additionalMarkersJson.data.length; i++) {
				let markerType = 1;
				if(this.additionalMarkersJson.data[i].icon === "diamond-c"){
					markerType = 2;
				}
				if(this.additionalMarkersJson.data[i].icon === "parking"){
					markerType = 3;
				}
				if(this.additionalMarkersJson.data[i].icon === "parking-bus"){
					markerType = 4;
				}
				if(this.additionalMarkersJson.data[i].icon === "zp"){
					markerType = 5;
				}
				this.markerData.push({
							"id": 1,
							"type": markerType,
							"lat": parseFloat(this.additionalMarkersJson.data[i].lat),
							"lng": parseFloat(this.additionalMarkersJson.data[i].lng),
				});
			}
		}


		this.initGoogleMap();
	}

	initGoogleMap = () => {
		let bounceLat = 0;
		let bounceLng = 0;
		if(this.element.dataset.bounce){
			bounceLat = 0.0008;
			bounceLng = 0.0035;
		}
		$.googlemap.setDefaults({
			lang: $('html').attr('lang'),
			mapOptions: {
				startingPosition: {
					lat: parseFloat(this.pointLatitude) + bounceLat,
					lng: parseFloat(this.pointLongitude) - bounceLng,
					zoom: this.pointZoomDefault,
				},
				mapTypeControl: false,
				scaleControl: false,
				panControl: false,
				streetViewControl: false,
				zoomControl: true,
				scrollwheel: true,
				draggable: true,
				styles: [
					{
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#f5f5f5"
							}
						]
					},
					{
						"elementType": "labels.icon",
						"stylers": [
							{
								"visibility": "off"
							}
						]
					},
					{
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#616161"
							}
						]
					},
					{
						"elementType": "labels.text.stroke",
						"stylers": [
							{
								"color": "#f5f5f5"
							}
						]
					},
					{
						"featureType": "administrative.land_parcel",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#bdbdbd"
							}
						]
					},
					{
						"featureType": "poi",
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#eeeeee"
							}
						]
					},
					{
						"featureType": "poi",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#757575"
							}
						]
					},
					{
						"featureType": "poi.park",
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#e5e5e5"
							}
						]
					},
					{
						"featureType": "poi.park",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#9e9e9e"
							}
						]
					},
					{
						"featureType": "road",
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#ffffff"
							}
						]
					},
					{
						"featureType": "road.arterial",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#757575"
							}
						]
					},
					{
						"featureType": "road.highway",
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#dadada"
							}
						]
					},
					{
						"featureType": "road.highway",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#616161"
							}
						]
					},
					{
						"featureType": "road.local",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#9e9e9e"
							}
						]
					},
					{
						"featureType": "transit.line",
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#e5e5e5"
							}
						]
					},
					{
						"featureType": "transit.station",
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#eeeeee"
							}
						]
					},
					{
						"featureType": "water",
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#c9c9c9"
							}
						]
					},
					{
						"featureType": "water",
						"elementType": "geometry.fill",
						"stylers": [
							{
								"color": "#b4d3e0"
							}
						]
					},
					{
						"featureType": "water",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#9e9e9e"
							}
						]
					}
				]
			},
			bubbleContentFormatter: false,
			markerTypes: [
				{},
				{
					icon: {
						url: '/img/maps/marker-' + this.pointMarkerIcon + '.png',
						size: new google.maps.Size(72, 72),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(36, 72)
					},
					shape: {
						coords: [0, 0, 72, 72],
						type: 'rect'
					}
				},
				{
					icon: {
						url: '/img/maps/marker-diamond-c.png',
						size: new google.maps.Size(72, 72),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(36, 72)
					},
					shape: {
						coords: [0, 0, 72, 72],
						type: 'rect'
					}
				},
				{
					icon: {
						url: '/img/maps/marker-parking.png',
						size: new google.maps.Size(72, 72),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(36, 72)
					},
					shape: {
						coords: [0, 0, 72, 72],
						type: 'rect'
					}
				},
				{
					icon: {
						url: '/img/maps/marker-parking-bus.png',
						size: new google.maps.Size(72, 72),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(36, 72)
					},
					shape: {
						coords: [0, 0, 72, 72],
						type: 'rect'
					}
				},
				{
					icon: {
						url: '/img/maps/marker-zp.png',
						size: new google.maps.Size(72, 72),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(36, 72)
					},
					shape: {
						coords: [0, 0, 72, 72],
						type: 'rect'
					}
				}

			]
		})
		this.map.googlemap();

		this.map.googlemap('loadMarkers', {
			data: this.markerData
		});

		window.google.maps._$map = this.map;

	}
}

export default GoogleMapContacts;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/GoogleMapContacts.js